import Image from 'next/image';
import { cn } from '@/lib/utils';
import { GROQImage } from '@/sanity/lib/types';

export default function HeroPaymentMethods({
  label,
  methods,
  className,
}: {
  label?: string;
  methods?: { label: string; logo: GROQImage }[];
  className?: string;
}) {
  if (!methods?.length) return null;

  return (
    <div
      className={cn(
        'flex flex-col gap-[0.75rem] items-center w-full',
        className,
      )}
    >
      {label && (
        <p className="font-medium opacity-50 text-[#103037] text-[1.5rem] text-center tracking-[-0.03rem] uppercase mb-0">
          {label}
        </p>
      )}
      <div className="flex gap-[1.5rem] items-center justify-center opacity-50 flex-wrap">
        {methods.map(({ label: name, logo }) => (
          <div
            key={name}
            className="flex flex-col items-center justify-center gap-[0.25rem]"
          >
            {logo?.src && (
              <div className="h-[2.5rem] relative flex items-center justify-center">
                <Image
                  src={logo.src}
                  alt={name}
                  width={logo.width ?? 42}
                  height={20}
                  className="object-contain h-[2.5rem] w-auto"
                />
              </div>
            )}
            <p className="font-medium text-[#103037] text-[1rem] text-center tracking-[-0.02rem] uppercase whitespace-nowrap mb-0">
              {name}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
